<template>
  <transition
    enter-active-class="ease-out duration-200"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-150"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="isOpen"
      class="fixed z-50 px-4 pt-16 flex items-start justify-center inset-0 sm:pt-24"
    >
      <div class="fixed inset-0" @click="isOpen = false">
        <div class="absolute inset-0 bg-gray-900 opacity-50"></div>
      </div>

      <transition
        enter-active-class="ease-out duration-200"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="ease-in duration-150"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <div
          v-show="isOpen"
          class="relative bg-gray-900 rounded-lg overflow-hidden shadow-xl transform transition-all max-w-lg w-full"
        >
          <ais-instant-search
            v-if="searchClient"
            :search-client="searchClient"
            index-name="central"
          >
            <ais-search-box>
              <div slot-scope="{ currentRefinement, refine }">
                <input
                  ref="search"
                  :value="currentRefinement"
                  @input="refine($event.currentTarget.value)"
                  @keydown.tab.prevent
                  @keydown.esc.prevent="isOpen = false"
                  type="text"
                  class="appearance-none w-full bg-transparent px-6 py-4 text-gray-300 text-lg placeholder-gray-500 focus:outline-none"
                  placeholder="Veranstaltungen und Bestellungen suchen"
                />

                <div class="border-t border-gray-800" v-show="currentRefinement.length > 0">
                  <ul style="max-height: 265px" class="overflow-y-auto">
                    <ais-hits>
                      <template slot="item" slot-scope="{ item }">
                        <li>
                          <a
                            v-if="item.type == 'event'"
                            @click="goToEvent(item.id)"
                            class="block px-6 py-3 hover:bg-gray-800 cursor-pointer"
                          >
                            <span class="text-gray-700 mr-3">
                              <font-awesome-icon icon="calendar" />
                            </span>
                            <span class="text-gray-300">{{ item.title }}</span>
                            <span class="ml-1 text-gray-500">{{
                              formatDateTimeForHuman(item.start_date.local)
                            }}</span>
                          </a>
                          <a
                            v-if="item.type == 'order'"
                            @click="goToOrder(item.id)"
                            class="block px-6 py-3 hover:bg-gray-800 cursor-pointer"
                          >
                            <span class="text-gray-700 mr-3">
                              <font-awesome-icon icon="shopping-bag" />
                            </span>
                            <span class="text-gray-300">{{ item.id }}</span>
                            <span class="ml-1 text-gray-500"
                              >{{ item.first_name }} {{ item.last_name }}</span
                            >
                          </a>
                        </li>
                      </template>
                    </ais-hits>
                  </ul>
                </div>
              </div>
            </ais-search-box>
          </ais-instant-search>
        </div>
      </transition>
    </div>
  </transition>
</template>




<script>
import algoliasearch from 'algoliasearch/lite';

import searchClient from '@/api/central/search';
import InteractsWithDates from '@/mixins/InteractsWithDates';

import {
  AisSearchBox,
  AisHits,
  AisInstantSearch,
  AisConfigure,
  AisAutocomplete,
} from 'vue-instantsearch';

export default {
  data() {
    return {
      searchClient: null,
      selected: null,
    };
  },
  mixins: [InteractsWithDates],
  components: {
    AisSearchBox,
    AisHits,
    AisInstantSearch,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.search.isOpen;
      },
      set(value) {
        this.$store.dispatch('search/set', value);
      },
    },
  },
  mounted() {
    searchClient.show().then(({ data: { data } }) => {
      this.searchClient = algoliasearch(data.app_id, data.token);
    });

    // document.onkeydown = (e) => {
    //   if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
    //     e.preventDefault(); // present "Save Page" from getting triggered.

    //     this.isOpen = true;
    //   }
    // };
  },
  methods: {
    goToEvent(id) {
      this.isOpen = false;
      this.$router.push({ name: 'events.dashboard', params: { id } });
    },
    goToOrder(id) {
      this.isOpen = false;
      this.$router.push({ name: 'orders.order', params: { id } });
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
  },
};
</script>